import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=537f157c&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('537f157c')) {
      api.createRecord('537f157c', component.options)
    } else {
      api.reload('537f157c', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=537f157c&", function () {
      api.rerender('537f157c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bCfFEmy1nm6w/JS/pricehelp.vue"
export default component.exports